import styled from "styled-components"
import media from "styled-media-query"

import Img from "gatsby-image"
import { Link } from "gatsby"

export const FooterWrapper = styled.footer`
  padding: 1.5rem 5rem;
  background-color: var(--alert_back);
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 9px solid var(--alert_hover);

  ${media.lessThan("large")`
    padding: .5rem;
  `}
`

export const FooterBox = styled.div`
  display: flex;
  align-items: center;

  ${media.lessThan("large")`
    flex-direction: column;
    align-items: flex-start;
  `}
`

export const FooterLogo = styled(Img)`
  margin-right: 1rem;
`

export const FooterText = styled.p`
  color: var(--white);
  margin-right: 0.5rem;

  ${media.lessThan("large")`
    font-size: .85rem;
    margin: .25rem;
  `}
`

export const FooterMenu = styled.nav`
  color: var(--white);
  text-decoration: none;

  ${media.lessThan("large")`
    display: flex;
    flex-direction: column;
    text-align: right;
  `}
`

export const FooterLink = styled.a`
  color: var(--alert_button);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export const FooterMenuItem = styled(Link)`
  padding: 0.25rem 0.5rem;
  margin: 0 0.5rem;
  cursor: pointer;
  color: var(--white);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  ${media.lessThan("large")`
    border-bottom: 1px solid #1a2fab;
    font-size: .75rem;
    margin: 0 0 .5rem 0;
    padding: 0.25rem 0;
  `}
`
